import { jsx as _jsx } from "react/jsx-runtime";
import { StateContainer } from './StateContainer';
import { StyledContainer } from './styles';
export const Container = ({ animate, className, children, disabled, isExpanded, onChange }) => {
    return (_jsx(StateContainer.Provider, { initialState: {
            animate,
            disabled,
            initialIsExpanded: isExpanded,
            onChange,
        }, children: _jsx(StyledContainer, { role: 'none', className: className, children: children }) }));
};
//# sourceMappingURL=Container.js.map